import recommenderIcon from '/src/assets/RecommenderIcon.svg';
import recommenderIconSelected from '/src/assets/RecommenderIconSelected.svg';

export default function NavRecommenderIconChatbot({isSelected}){

    return <>
        {isSelected ?
            <div className="bot-utn-app-navigation-recommender-icon">
            <img
                className="bot-utn-recommender-nav-bar-icons"
                src={recommenderIconSelected}
                alt="ChatBot Image"
            />
            </div> :
            <div className="bot-utn-app-navigation-recommender-icon">
            <img
                className="bot-utn-recommender-nav-bar-icons"
                src={recommenderIcon}
                alt="Recommender Image"
            />
            </div>
        }
    </>
}